import React from 'react';
import baseStyles from "./styles.module.css.js";
import useStyleOverride from "../../../hooks/useStyleOverride.js";
import useComponentOverride from "../../../hooks/useComponentOverride.js";
export var PopoverHeading = _ref => {
  var {
    result,
    onDismiss,
    showCloseButton = true
  } = _ref;
  var styles = useStyleOverride('GoogleMaps/Popover/PopoverHeading', baseStyles);
  var [PopoverCloseButton] = useComponentOverride('GoogleMaps/Popover/PopoverCloseButton');
  return /*#__PURE__*/React.createElement("div", {
    className: styles.PopoverHeading
  }, /*#__PURE__*/React.createElement("h2", {
    className: styles.locationName
  }, result.locationName), showCloseButton && /*#__PURE__*/React.createElement(PopoverCloseButton, {
    onClick: onDismiss ? e => onDismiss(e, result) : undefined
  }));
};
export default PopoverHeading;
//# sourceMappingURL=index.js.map